module.exports = __webpack_public_path__ + "img/Icon1.5058288c.svg";